import React, { useState } from 'react';

import {
  Text, Stack, useToast, Menu, MenuButton, MenuList, HStack, Spinner, Center,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { utils, Calendar } from 'react-modern-calendar-datepicker';
import { useMutation } from 'react-query';

import api from 'api';
import { Button, Icon } from 'components';
import { locale } from 'constants/translations';
import colors from 'theme/colors';

export default function GenerateReport({
  onSuccess = () => {},
  ...rest
}) {
  const toast = useToast();
  const [date, setDate] = useState(utils('en').getToday());

  const {
    mutate,
    isLoading,
  } = useMutation(() => api().get('report', {
    params: {
      date: dayjs().set('date', date?.day).set('month', date?.month - 1).set('year', date?.year)
        .format('DD/MM/YYYY'),
    },
  }), {
    onSuccess: ({ data }) => {
      toast({
        title: 'Relatórios foram gerados com sucesso!',
        description: 'Verifique seus downloads!',
        status: 'success',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
      window.open(data);
      onSuccess();
    },
    onError: ({ errors }: {errors: any[]}) => {
      toast({
        title: 'Ocorreu um erro!',
        description: errors?.map(({ message }) => message),
        status: 'error',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
    },
  });
  return (
    <>
      <Menu>
        <Button
          as={MenuButton}
          mr={4}
          size="xs"
          _hover={{ bg: 'gray.200' }}
          bg="white"
          {...rest}>
          {isLoading
            ? (
              <Center>
                <Spinner />
              </Center>
            )
            : (
              <HStack>
                <Text
                  variant="xSmallBold"
                  color="gray.500">
                  Gerar relatórios
                </Text>
                <Icon
                  color="gray.500"
                  name="file-excel"
                />
              </HStack>
            )}
        </Button>
        <MenuList>
          <Stack p={4}>
            <Calendar
              value={date}
              onChange={setDate}
              colorPrimary={colors.primary.default}
              colorPrimaryLight={colors.primary.transparent}
              shouldHighlightWeekends
              maximumDate={utils('en').getToday()}
              onDisabledDayError={() => toast({
                description: 'Não é possivel ver o futuro!',
                isClosable: true,
                title: 'Data inválida',
                status: 'error',
                duration: 5000,
                position: 'top-right',
              })}
              locale={locale}
            />
            <Button
              w="min"
              onClick={() => mutate()}
              alignSelf="flex-end"
              size="sm">
              Confirmar
            </Button>
          </Stack>
        </MenuList>
      </Menu>
    </>
  );
}
